var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "data_icon01",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.734,
    height: 51.704,
    viewBox: "0 0 45.734 51.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_157",
    "data-name": "\\uADF8\\uB8F9 157",
    transform: "translate(0 7.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_156",
    "data-name": "\\uADF8\\uB8F9 156",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_81",
    "data-name": "\\uD328\\uC2A4 81",
    d: "M2115.755,679.349h-24.782a2.953,2.953,0,0,1-2.95-2.95V641.8a2.953,2.953,0,0,1,2.95-2.95h24.782a2.953,2.953,0,0,1,2.95,2.95v34.6A2.953,2.953,0,0,1,2115.755,679.349Zm-24.782-38.854a1.306,1.306,0,0,0-1.3,1.3v34.6a1.306,1.306,0,0,0,1.3,1.3h24.782a1.306,1.306,0,0,0,1.3-1.3V641.8a1.306,1.306,0,0,0-1.3-1.3Z",
    transform: "translate(-2088.023 -638.849)",
    fill: "#005ca6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162",
    "data-name": "\\uADF8\\uB8F9 162",
    transform: "translate(3.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_159",
    "data-name": "\\uADF8\\uB8F9 159",
    transform: "translate(0.198 0.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_158",
    "data-name": "\\uADF8\\uB8F9 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_82",
    "data-name": "\\uD328\\uC2A4 82",
    d: "M2110.646,648.445a2.342,2.342,0,0,1-2.339-2.339V607.875a2.342,2.342,0,0,1,2.339-2.339h17.064l12.98,12.98v27.59a2.341,2.341,0,0,1-2.339,2.339Z",
    transform: "translate(-2107.682 -604.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_83",
    "data-name": "\\uD328\\uC2A4 83",
    d: "M2135.977,646.694h-27.705a2.967,2.967,0,0,1-2.964-2.964V605.5a2.967,2.967,0,0,1,2.964-2.964h17.323l13.346,13.346v27.848A2.967,2.967,0,0,1,2135.977,646.694Zm-27.705-42.909a1.716,1.716,0,0,0-1.714,1.714v38.231a1.716,1.716,0,0,0,1.714,1.714h27.705a1.716,1.716,0,0,0,1.714-1.714V616.4l-12.614-12.614Z",
    transform: "translate(-2105.308 -602.536)",
    fill: "#346286"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_161",
    "data-name": "\\uADF8\\uB8F9 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_160",
    "data-name": "\\uADF8\\uB8F9 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_84",
    "data-name": "\\uD328\\uC2A4 84",
    d: "M2126.877,604.982l12.864,12.864v27.508a2.144,2.144,0,0,1-2.141,2.141H2109.9a2.143,2.143,0,0,1-2.141-2.141V607.123a2.143,2.143,0,0,1,2.141-2.141h16.982m.164-.4H2109.9a2.536,2.536,0,0,0-2.536,2.536v38.231a2.536,2.536,0,0,0,2.536,2.536H2137.6a2.536,2.536,0,0,0,2.536-2.536V617.683l-13.1-13.1Z",
    transform: "translate(-2106.734 -603.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_85",
    "data-name": "\\uD328\\uC2A4 85",
    d: "M2135.226,646.141H2107.52a3.165,3.165,0,0,1-3.161-3.161V604.749a3.165,3.165,0,0,1,3.161-3.161h17.4l13.462,13.462v27.93A3.165,3.165,0,0,1,2135.226,646.141Zm-27.705-42.908a1.518,1.518,0,0,0-1.516,1.516V642.98a1.518,1.518,0,0,0,1.516,1.516h27.705a1.518,1.518,0,0,0,1.516-1.516V615.731l-12.5-12.5Z",
    transform: "translate(-2104.359 -601.588)",
    fill: "#005ca6"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_164",
    "data-name": "\\uADF8\\uB8F9 164",
    transform: "translate(6.79 13.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_163",
    "data-name": "\\uADF8\\uB8F9 163",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86",
    "data-name": "\\uD328\\uC2A4 86",
    d: "M2133.855,671.9h-12.4a.844.844,0,0,1-.842-.842v-1.569a.844.844,0,0,1,.842-.842h12.4a.844.844,0,0,1,.842.842v1.569A.844.844,0,0,1,2133.855,671.9Zm-11.99-1.25h11.583v-.754h-11.583Z",
    transform: "translate(-2120.615 -668.645)",
    fill: "#005ca6"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_166",
    "data-name": "\\uADF8\\uB8F9 166",
    transform: "translate(6.79 18.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165",
    "data-name": "\\uADF8\\uB8F9 165",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_87",
    "data-name": "\\uD328\\uC2A4 87",
    d: "M2133.855,693.275h-12.4a.844.844,0,0,1-.842-.842v-1.569a.844.844,0,0,1,.842-.843h12.4a.844.844,0,0,1,.842.843v1.569A.844.844,0,0,1,2133.855,693.275Zm-11.99-1.25h11.583v-.754h-11.583Z",
    transform: "translate(-2120.615 -690.021)",
    fill: "#005ca6"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_168",
    "data-name": "\\uADF8\\uB8F9 168",
    transform: "translate(6.79 22.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_167",
    "data-name": "\\uADF8\\uB8F9 167",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_88",
    "data-name": "\\uD328\\uC2A4 88",
    d: "M2133.855,714.653h-12.4a.844.844,0,0,1-.842-.842v-1.569a.844.844,0,0,1,.842-.843h12.4a.844.844,0,0,1,.842.843v1.569A.844.844,0,0,1,2133.855,714.653Zm-11.99-1.25h11.583v-.754h-11.583Z",
    transform: "translate(-2120.615 -711.399)",
    fill: "#005ca6"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_170",
    "data-name": "\\uADF8\\uB8F9 170",
    transform: "translate(6.79 27.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_169",
    "data-name": "\\uADF8\\uB8F9 169",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_89",
    "data-name": "\\uD328\\uC2A4 89",
    d: "M2133.855,736.031h-12.4a.843.843,0,0,1-.842-.842V733.62a.844.844,0,0,1,.842-.843h12.4a.844.844,0,0,1,.842.843v1.569A.843.843,0,0,1,2133.855,736.031Zm-11.99-1.25h11.583v-.754h-11.583Z",
    transform: "translate(-2120.615 -732.777)",
    fill: "#005ca6"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_175",
    "data-name": "\\uADF8\\uB8F9 175",
    transform: "translate(19.793 24.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172",
    "data-name": "\\uADF8\\uB8F9 172",
    transform: "translate(0.196 0.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171",
    "data-name": "\\uADF8\\uB8F9 171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_90",
    "data-name": "\\uD328\\uC2A4 90",
    d: "M2197.262,747.588a3.473,3.473,0,0,1-1.4-.284,3.226,3.226,0,0,1-1.907-2.938l-.084-.515-3.907-1.964c-.048-.018-2.387-.836-2.894-2.154a1.411,1.411,0,0,1,.118-1.249,1.869,1.869,0,0,1,1.768-.963,6.543,6.543,0,0,1,2.745.824l.428.248-4.2-14.264a2.013,2.013,0,0,1,.926-2.346,2.365,2.365,0,0,1,.242-.114,1.84,1.84,0,0,1,.689-.134,2.059,2.059,0,0,1,1.945,1.495l1.64,5.575.38-.109a2.166,2.166,0,0,1,.962-2.476,2.22,2.22,0,0,1,.913-.278c.054,0,.107-.007.16-.007a2.166,2.166,0,0,1,2.025,1.574l.38-.11a2.093,2.093,0,0,1,4.023-1.153l.379-.113a1.993,1.993,0,0,1,.959-2.368c.079-.04.158-.075.237-.106a2.079,2.079,0,0,1,.762-.145,2.318,2.318,0,0,1,2.157,1.6c1.049,3.174,3.572,10.907,4.343,14.15.932,3.921-1.367,4.833-1.465,4.87l-11.173,3.286a4.1,4.1,0,0,1-1.154.169Z",
    transform: "translate(-2186.35 -721.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_91",
    "data-name": "\\uD328\\uC2A4 91",
    d: "M2194.885,745.837a4.1,4.1,0,0,1-1.651-.336,3.855,3.855,0,0,1-2.281-3.458l-.025-.153-3.59-1.8c-.655-.24-2.684-1.086-3.229-2.5a2.026,2.026,0,0,1,.155-1.776,2.484,2.484,0,0,1,2.315-1.285,6.035,6.035,0,0,1,2.165.484l-3.787-12.874a2.64,2.64,0,0,1,1.228-3.072,3.054,3.054,0,0,1,.306-.143,2.459,2.459,0,0,1,.922-.179,2.687,2.687,0,0,1,2.545,1.943l1.07,3.639a2.625,2.625,0,0,1,1.006-1.018,2.838,2.838,0,0,1,1.167-.356,2.687,2.687,0,0,1,2.04.73,2.706,2.706,0,0,1,4.365-1.254,2.533,2.533,0,0,1,1.289-1.587c.094-.047.191-.091.291-.13a2.693,2.693,0,0,1,.99-.188,2.95,2.95,0,0,1,2.751,2.027c1.051,3.183,3.581,10.938,4.357,14.2,1.059,4.455-1.735,5.555-1.854,5.6l-.042.014-11.173,3.286A4.719,4.719,0,0,1,2194.885,745.837Zm-8.305-10.067a1.235,1.235,0,0,0-1.221.641.791.791,0,0,0-.082.722,4.6,4.6,0,0,0,2.515,1.787l.076.032,4.191,2.107.145.887v.058a2.592,2.592,0,0,0,1.533,2.35,3.139,3.139,0,0,0,2.128.088l11.144-3.278c.184-.079,1.833-.888,1.062-4.134-.765-3.217-3.282-10.931-4.328-14.1a1.686,1.686,0,0,0-1.564-1.169,1.452,1.452,0,0,0-.533.1c-.061.024-.122.051-.183.082a1.374,1.374,0,0,0-.642,1.635l.176.6-1.572.469-.181-.6a1.472,1.472,0,0,0-1.847-.981,1.47,1.47,0,0,0-.975,1.786l.166.6-1.568.454-.178-.592a1.526,1.526,0,0,0-1.535-1.125,1.6,1.6,0,0,0-.658.2,1.535,1.535,0,0,0-.667,1.76l.17.6-1.575.455-1.816-6.172a1.431,1.431,0,0,0-1.345-1.046,1.218,1.218,0,0,0-.456.089,1.783,1.783,0,0,0-.179.084,1.385,1.385,0,0,0-.621,1.618l4.638,15.765-1.783-1.032A5.925,5.925,0,0,0,2186.58,735.77Z",
    transform: "translate(-2183.973 -718.736)",
    fill: "#346286"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_174",
    "data-name": "\\uADF8\\uB8F9 174",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173",
    "data-name": "\\uADF8\\uB8F9 173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_92",
    "data-name": "\\uD328\\uC2A4 92",
    d: "M2189.042,721.182a1.885,1.885,0,0,1,1.755,1.352l3.081,10.475.759-.223-1.434-4.877a1.964,1.964,0,0,1,.863-2.269,2.03,2.03,0,0,1,.832-.254c.048,0,.1-.006.144-.006a1.965,1.965,0,0,1,1.839,1.446l1.435,4.878.759-.223-1.43-4.859a1.895,1.895,0,0,1,3.638-1.059l1.414,4.806.759-.223-1.414-4.806-.007-.025a1.792,1.792,0,0,1,.862-2.125q.11-.056.22-.1a1.882,1.882,0,0,1,.69-.131,2.118,2.118,0,0,1,1.969,1.462c1.048,3.169,3.567,10.89,4.338,14.134.869,3.654-1.16,4.565-1.332,4.635l-11.17,3.285a3.893,3.893,0,0,1-1.1.161,3.275,3.275,0,0,1-1.321-.267,3.036,3.036,0,0,1-1.789-2.751v-.039l-.007-.038-.065-.379-.034-.2-.178-.09-3.817-1.92-.024-.012-.025-.009c-.632-.218-2.357-1.006-2.75-2.028a1.223,1.223,0,0,1,.107-1.082,1.662,1.662,0,0,1,1.595-.861,6.339,6.339,0,0,1,2.646.8l.857.5-.279-.949-4.056-13.789a1.814,1.814,0,0,1,.829-2.116,2.215,2.215,0,0,1,.223-.1,1.634,1.634,0,0,1,.615-.119h0m0-.4a2.036,2.036,0,0,0-.763.148,2.579,2.579,0,0,0-.262.123,2.211,2.211,0,0,0-1.021,2.575l4.056,13.788a6.7,6.7,0,0,0-2.844-.851,2.064,2.064,0,0,0-1.941,1.065c-1.253,2.264,2.86,3.676,2.86,3.676l3.817,1.919.064.379a3.455,3.455,0,0,0,2.025,3.124,3.685,3.685,0,0,0,1.479.3,4.3,4.3,0,0,0,1.21-.177l11.186-3.29s2.577-.945,1.588-5.1c-.775-3.259-3.3-10.984-4.348-14.166a2.512,2.512,0,0,0-2.345-1.734,2.276,2.276,0,0,0-.834.159q-.127.05-.253.114a2.2,2.2,0,0,0-1.063,2.589l.008.025v0l1.413,4.8-1.414-4.806a2.29,2.29,0,0,0-4.4,1.282l1.429,4.86-1.435-4.878a2.365,2.365,0,0,0-2.218-1.729c-.058,0-.117,0-.176.007a2.415,2.415,0,0,0-.993.3,2.355,2.355,0,0,0-1.049,2.725l1.434,4.877-3.081-10.475a2.269,2.269,0,0,0-2.135-1.636Z",
    transform: "translate(-2185.406 -720.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_93",
    "data-name": "\\uD328\\uC2A4 93",
    d: "M2194.142,745.284a4.294,4.294,0,0,1-1.73-.353,4.046,4.046,0,0,1-2.4-3.643l0-.016-3.5-1.759c-.424-.15-2.72-1.029-3.328-2.611a2.246,2.246,0,0,1,.166-1.944,2.672,2.672,0,0,1,2.488-1.387,5.8,5.8,0,0,1,1.863.356l-3.675-12.492a2.838,2.838,0,0,1,1.324-3.3,3.152,3.152,0,0,1,.325-.153,2.653,2.653,0,0,1,.994-.193h0a2.885,2.885,0,0,1,2.734,2.085l.951,3.231a2.786,2.786,0,0,1,.84-.726,3.047,3.047,0,0,1,1.247-.381,2.842,2.842,0,0,1,1.967.591,2.9,2.9,0,0,1,4.355-1.247,2.72,2.72,0,0,1,1.3-1.435c.1-.05.2-.1.307-.137a2.893,2.893,0,0,1,1.063-.2,3.149,3.149,0,0,1,2.938,2.162c1.052,3.182,3.582,10.937,4.362,14.218,1.1,4.642-1.95,5.821-1.981,5.832l-.039.013-11.186,3.29A4.911,4.911,0,0,1,2194.142,745.284Zm-8.306-10.067a1.034,1.034,0,0,0-1.048.539.6.6,0,0,0-.07.555c.255.664,1.565,1.384,2.37,1.662l.125.052,4.279,2.152.168.986,0,.1a2.4,2.4,0,0,0,1.414,2.161,2.944,2.944,0,0,0,1.993.079l11.133-3.275c.208-.1,1.653-.889.937-3.9-.766-3.221-3.279-10.921-4.324-14.082a1.487,1.487,0,0,0-1.376-1.033,1.248,1.248,0,0,0-.461.088,1.813,1.813,0,0,0-.166.074,1.169,1.169,0,0,0-.545,1.391l.007.023,1.591,5.408-1.958.576-1.59-5.406a1.275,1.275,0,0,0-1.6-.855,1.266,1.266,0,0,0-.838,1.562l1.605,5.459-1.958.576-1.611-5.477a1.326,1.326,0,0,0-1.334-.993,1.408,1.408,0,0,0-.576.176,1.336,1.336,0,0,0-.569,1.547l1.611,5.476-1.958.576-3.258-11.075a1.265,1.265,0,0,0-1.156-.9,1.021,1.021,0,0,0-.382.074,1.663,1.663,0,0,0-.159.075,1.187,1.187,0,0,0-.526,1.389l4.776,16.238-2.21-1.278A5.74,5.74,0,0,0,2185.836,735.216Z",
    transform: "translate(-2183.034 -717.787)",
    fill: "#005ca6"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_188",
    "data-name": "\\uADF8\\uB8F9 188",
    transform: "translate(21.694 13.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184",
    "data-name": "\\uADF8\\uB8F9 184",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_180",
    "data-name": "\\uADF8\\uB8F9 180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_177",
    "data-name": "\\uADF8\\uB8F9 177",
    transform: "translate(0.198 0.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_176",
    "data-name": "\\uADF8\\uB8F9 176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_94",
    "data-name": "\\uD328\\uC2A4 94",
    d: "M2198.3,678.469a5.2,5.2,0,1,1,5.2-5.2A5.2,5.2,0,0,1,2198.3,678.469Zm0-9.144a3.947,3.947,0,1,0,3.947,3.947A3.952,3.952,0,0,0,2198.3,669.325Z",
    transform: "translate(-2193.105 -668.075)",
    fill: "#005ca6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_179",
    "data-name": "\\uADF8\\uB8F9 179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_178",
    "data-name": "\\uADF8\\uB8F9 178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_95",
    "data-name": "\\uD328\\uC2A4 95",
    d: "M2197.551,677.916a5.395,5.395,0,1,1,5.395-5.4A5.4,5.4,0,0,1,2197.551,677.916Zm0-9.144a3.749,3.749,0,1,0,3.749,3.749A3.754,3.754,0,0,0,2197.551,668.771Z",
    transform: "translate(-2192.156 -667.126)",
    fill: "#005ca6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_183",
    "data-name": "\\uADF8\\uB8F9 183",
    transform: "translate(0.223 1.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181",
    "data-name": "\\uADF8\\uB8F9 181",
    transform: "translate(0.655 0.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_96",
    "data-name": "\\uD328\\uC2A4 96",
    d: "M2201.038,681.072l-4.665-1.661.42-1.178,4,1.425,3.415-2.779.789.97Z",
    transform: "translate(-2196.373 -676.88)",
    fill: "#005ca6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182",
    "data-name": "\\uADF8\\uB8F9 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_97",
    "data-name": "\\uD328\\uC2A4 97",
    d: "M2198.586,679.214l-5.358-1.908.553-1.55,4.485,1.6,3.813-3.1,1.038,1.276Z",
    transform: "translate(-2193.228 -674.25)",
    fill: "#005ca6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_187",
    "data-name": "\\uADF8\\uB8F9 187",
    transform: "translate(4.417 4.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185",
    "data-name": "\\uADF8\\uB8F9 185",
    transform: "translate(0.609 0.548)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_189",
    "data-name": "\\uC0AC\\uAC01\\uD615 189",
    width: 1.25,
    height: 4.562,
    transform: "translate(0 0.969) rotate(-50.807)",
    fill: "#005ca6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186",
    "data-name": "\\uADF8\\uB8F9 186",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_190",
    "data-name": "\\uC0AC\\uAC01\\uD615 190",
    width: 1.646,
    height: 5.812,
    transform: "matrix(0.632, -0.775, 0.775, 0.632, 0, 1.275)",
    fill: "#005ca6"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_190",
    "data-name": "\\uADF8\\uB8F9 190",
    transform: "translate(21.812 14.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_189",
    "data-name": "\\uADF8\\uB8F9 189",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_98",
    "data-name": "\\uD328\\uC2A4 98",
    d: "M2198.163,674.761l-5.439-1.994.283-.616a5.69,5.69,0,0,1,5.121-3.355,5.563,5.563,0,0,1,4.015,1.712l.5.5Zm-3.691-2.686,3.442,1.263,2.85-2.388a4.289,4.289,0,0,0-2.637-.9A4.4,4.4,0,0,0,2194.473,672.075Z",
    transform: "translate(-2192.724 -668.796)",
    fill: "#005ca6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon01);
export default __webpack_public_path__ + "static/media/data_icon01.3d6cac8c5402a5d1dc68b6c28c265cdd.svg";
export { ForwardRef as ReactComponent };